import {LoggerAppenderConfig} from '../logger-appender-config';
import {LogLevel} from '../../log-level';

/**
 * Sentry Breadcrumbs appender config
 */
export class SentryBreadcrumbsAppenderConfig extends LoggerAppenderConfig {
  enabled = !IS_DEVELOPMENT;
  contextSize = 0;
  triggerLevel = LogLevel.Debug;
}
